import fetchWithRetry from './fetchWithRetry';


/**
 * A wrapped fetch call for retrieving a JSON response which logs errors and potentially retries transient errors.
 * @param {string} url
 * @param {object} options
 * @param {Boolean} options.canRetry - If we should attempt retries based on specific criteria. Defaults to true.
 * @returns {object}
 */
async function fetchWithErrorHandling(url, options) {
    // Unless specifically told not to, attempt retries
    const response = options?.canRetry !== false
        ? await fetchWithRetry(url, options)
        : await fetch(url, options);

    // Check for failure
    if (!response.ok) {
        // We want to access response body on non-200 status
        // ex) authenticateMagicToken / verify
        let responseBody = null;
        try {
            responseBody = await response.text();
            responseBody = JSON.parse(responseBody);
        } catch {
            // eslint-disable-next-line no-empty
        }
        throw new FetchError(`Response code was not HTTP 2xx. Received: ${response.status}`, response, responseBody);
    }

    return response;
}

/** A custom Error class where we can include the response object for logging and introspection */
class FetchError extends Error {
    constructor(message, response, responseBody) {
        super(message);
        this.response = response;
        this.responseBody = responseBody;
        this.status = response.status;
        this.url = response.url;
    }
}

export { FetchError };
export default fetchWithErrorHandling;
